<template>
    <section class="mgt-5 mgb-5 general-detail-section" v-if="model">
        <div class="container-fluid">
            <div class="container custom-container">
                <div class="row general-box">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="return-btn-container">
                            <a :href="getBackLink()">
                                <i class="fad fa-long-arrow-alt-left"></i>
                                <span> Inapoi </span>
                            </a>
                        </div>
                        <div class="model-heading model-heading--developer-model mb-4">
                            <i class="fad fa-layer-group"></i>
                            <h1 v-if="model.type != 'commercial'"> {{ model.rooms_count ? model.rooms_count.name +', ' : ''}} tip {{ model.model_type }},
                                Proiect {{ project.name }}, {{ project.city.name }} </h1>
                            <h1 v-if="model.type == 'commercial'"> Spatiu comercial tip {{ model.model_type }},
                                Proiect {{ project.name }}, {{ project.city.name }} </h1>
                        </div>
                        <div class="developer-model-edit-buttons">
                            <button type="button" class="general-btn positive-btn"
                                @click="openEditModelItemsModal(model.id)"
                                v-if="canManage">
                                <span><i class="fas fa-plus"></i> Adauga/Modifica lista disponibilitati </span>
                            </button>
                            <a :href="`/developer/${model.project_id}/model/${model.id}/edit`" class="general-btn positive-btn" title="Modifica detalii model">
                                <span>
                                    <i class="fas fa-edit"></i> Modifica detalii model
                                </span>
                            </a>
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-12">
                        <ul class="nav nav-tabs model-detail-tablist" role="tablist">
                            <li class="nav-item" @click="initGalery()">
                                <!-- <a class="nav-link" :class="model.buildings.length === 0 ? 'active' : '' " -->
                                <a class="nav-link"
                                   data-toggle="tab" href="#modelDetails" role="tab" aria-controls="modelDetails"
                                   aria-selected="true">
                                    <i class="fad fa-building"></i>
                                    <span> Poze si detalii </span>
                                </a>
                            </li>
                            <!-- <li>
                                <h3> Disponibilitati </h3>
                            </li> -->
                            <li class="nav-item" v-for="(building, index) in buildings" :key="index"
                                @click="activeBuilding = building">
                                <a class="nav-link" :class="building.id === activeBuilding.id ? 'active' : '' "
                                   data-toggle="tab" href="#model-details-tab-block" role="tab"
                                   aria-controls="model-details-tab-block" aria-selected="true">
                                    <i class="fad fa-city"></i>
                                    <span> Bloc {{ building.name }} </span>
                                    <span class="date"> {{ building.finalized_date }} </span>
                                    <p class="general-counter"> {{ building.items_count }} </p>
                                </a>
                            </li>
                            <li class="nav-item" v-if="model.type === 'house'">
                                <a class="nav-link"
                                   data-toggle="tab" href="#model-details-tab-house" role="tab"
                                   aria-controls="model-details-tab-house" aria-selected="true">
                                    <i class="fad fa-house"></i>
                                    <span> Case </span>
                                    <p class="general-counter"> {{ model.items.filter(item => item.status === 'available').length }} </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xl-10 col-lg-9 col-md-8 col-sm-12 col-12 element-body">
                        <div class="tab-content mt-3" id="tabsContent">
                            <!-- <div class="tab-pane custom-tab-panel fade categories-tabs-wrapper"
                                 :class="model.buildings.length === 0 ? 'show active' : '' " id="modelDetails"
                                 role="tabpane" aria-labelledby="modelDetails"> -->
                            <div class="tab-pane custom-tab-panel fade categories-tabs-wrapper" id="modelDetails" role="tabpane" aria-labelledby="modelDetails">
                                <div class="row">
                                    <div class="col-xl-8 col-lg-8 col-md-12 col-12 mgb-3">
                                        <div class="project-model-gallery">
                                            <div class="detail-gallery-container">
                                                <div class="swiper-container gallery-top model-gallery-top">
                                                    <div class="swiper-wrapper pp-model-gallery">

                                                        <a :href="image" v-for="(image, index) in images" :key="`img-${index}`" class="swiper-slide"
                                                            :style="{ backgroundImage: 'url(' + image + ')' }">
                                                            <img style="display: none;" :src="image" alt="">
                                                        </a>

                                                        <a :href="video.link" class="swiper-slide" v-for="(video, index) in model.videos" :key="index">
                                                            <h6> {{video.name}} </h6>
                                                            <div class="swiper-video-box">
                                                                <object :data="displayVideo(video.link)" class="video_object"></object>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <!-- Add Arrows -->
                                                    <div class="swiper-button-next model-swiper-button-next swiper-button-white"></div>
                                                    <div class="swiper-button-prev model-swiper-button-prev swiper-button-white"></div>
                                                </div>
                                                <div class="gallery-content-info">
                                                    <div class="gallery-content-cell" @click="modelGoToSlide(0)">
                                                        <i class="fad fa-images"></i>
                                                        <p> Poze </p>
                                                        <span> ({{model.media.length}}) </span>
                                                    </div>
                                                    <div class="gallery-content-cell" @click="modelGoToSlide(model.media.length)">
                                                        <i class="fad fa-video"></i>
                                                        <p> Video </p>
                                                        <span> ({{model.videos.length}}) </span>
                                                    </div>
                                                </div>
                                                <div class="swiper-container gallery-thumbs model-gallery-thumbs">
                                                    <div class="swiper-wrapper">
                                                        <div class="swiper-slide kitchen"
                                                             v-for="(image, index) in thumbs" :key="`img-${index}`"
                                                             :style="{ backgroundImage: 'url(' + image + ')' }"
                                                        ></div>
                                                        <div class="swiper-slide" v-for="(video, index) in model.videos" :key="index">
                                                            <div class="video-thumb">
                                                                <i class="fad fa-video"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="model-thumbs-button-next swiper-button-next swiper-button-white"></div>
                                                    <div class="model-thumbs-button-prev swiper-button-prev swiper-button-white"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-4 col-md-12 col-12">
                                        <div class="row">
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-12 mgb-3">
                                                <div class="element-section-heading">
                                                    <h3> Descriere </h3>
                                                </div>
                                                <div class="description-box">
                                                    <div class="section-box-icon">
                                                        <i class="fad fa-align-left"></i>
                                                    </div>
                                                    <p v-html="model.description"></p>
                                                </div>
                                            </div>
                                            <div class="col-xl-12 col-lg-12 col-md-12 col-12 mgb-3" v-if="model.show_payment_methods">
                                                <div class="element-section-heading">
                                                    <h3> Modalitate Plata </h3>
                                                </div>
                                                <div class="description-box">
                                                    <div class="section-box-icon">
                                                        <i class="fad fa-euro-sign"></i>
                                                    </div>
                                                    <p v-html="project.payment_method"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade show active" id="model-details-tab-block" role="tabpanel"
                                 aria-labelledby="model-details-tab-block" v-if="activeBuilding">
                                <div class="pdetail-levels-container levels-container">
                                    <div class="single-level-wrapper" v-for="(level, index) in levels" :key="index">
                                        <h3 class="collapse-trigger" data-toggle="collapse"
                                            :data-target="`#floortarget_${level.level.id}`" aria-expanded="false"
                                            :aria-controls="`floortarget_${level.level.id}`">
                                            <span>
                                                {{ level.level.name }}
                                            </span>
                                            <i class="fad fa-arrow-alt-circle-up"></i>
                                        </h3>
                                        <div class="collapse-list collapse multi-collapse show"
                                             :id="`floortarget_${level.level.id}`">
                                            <div class="single-level-row pdetail-level-row"
                                                 :class="[
                                                   item.status !== 'available' ? 'highlighted-row-unavailable' : 'highlighted-row-available',
                                                   (urlParams.item && item.id == urlParams.item) ? 'highlighted-scroll' : ''
                                                 ]"
                                                 :style="(urlParams.item && item.id == urlParams.item) ? 'border: 3px solid #6771e2' : ''"
                                                 v-for="(item, itemIndex) in level.items"
                                                 :key="itemIndex">
                                                <div class="row" :id="`item_${item.id}`">
                                                    <div class="col-xl-1 col-lg-1 col-md-12 col-sm-12">
                                                        <div class="level-item-nr level-strip-cell">
                                                            <p class="level-cell-heading"> Nr Ap. </p>
                                                            <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id)"> {{ item.apartment_number }} </p>
                                                            <div class="input-container" v-if="isItemInEditMode(item.id)">
                                                                <div class="input-group">
                                                                    <input type="text" class="apartment_number" v-model="editableItems[item.id].apartment_number">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-3 col-lg-4 col-md-12 col-sm-12">
                                                        <p class="level-cell-heading"> Suprafata (m²)</p>
                                                        <div class="level-item-size level-strip-cell pdetail-level-cell">
                                                            <div class="pdetail-surface-type">
                                                                <span> Totala: </span>
                                                                <span v-if="!isItemInEditMode(item.id)"> {{ item.useful_surface }} </span>
                                                                <div class="input-container" v-if="isItemInEditMode(item.id)">
                                                                    <div class="input-group mg-b">
                                                                        <input type="number" class="useful_surface" v-model="editableItems[item.id].useful_surface">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="pdetail-surface-type">
                                                                <span> Balcon: </span>
                                                                <span v-if="!isItemInEditMode(item.id)"> {{ item.terrace_surface }} </span>
                                                                <div class="input-container" v-if="isItemInEditMode(item.id)">
                                                                    <div class="input-group mg-b">
                                                                        <input type="number" class="terrace_surface" v-model="editableItems[item.id].terrace_surface">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> Pret </p>
                                                            <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id)"> {{ itemPrices[item.id] }} ({{ itemPricesWithVat[item.id] ? 'TVA inclus' : '+TVA'}})</p>
                                                            <div class="input-container" v-if="isItemInEditMode(item.id)">
                                                                <div class="input-group">
                                                                    <input type="text" class="price" v-model="editableItems[item.id].price">
                                                                </div>
                                                            </div>
                                                            <div class="input-container" v-if="isItemInEditMode(item.id)">
                                                                <div class="input-group mg-b">
                                                                    <select class="status" v-model="editableItems[item.id].price_with_vat">
                                                                        <option value="0"> +TVA </option>
                                                                        <option value="1"> TVA Inclus </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> Pret cu credit </p>
                                                            <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id) && item.credit_price"> {{ itemCreditPrices[item.id] }} ({{ itemCreditPricesWithVat[item.id] ? 'TVA inclus' : '+TVA'}}) </p>
                                                            <p class="highlighted-info-strip" v-else-if="!isItemInEditMode(item.id)"> -- </p>
                                                            <div class="input-container" v-if="isItemInEditMode(item.id)">
                                                                <div class="input-group">
                                                                    <input type="text" class="credit_price" v-model="editableItems[item.id].credit_price">
                                                                </div>
                                                            </div>
                                                            <div class="input-container" v-if="isItemInEditMode(item.id)">
                                                                <div class="input-group mg-b">
                                                                    <select class="status" v-model="editableItems[item.id].credit_price_with_vat">
                                                                        <option value="0"> +TVA </option>
                                                                        <option value="1"> TVA Inclus </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                                                        <div class="level-item-size level-strip-cell">
                                                            <p class="level-cell-heading"> Status </p>
                                                            <p class="highlighted-info-strip" v-if="!isItemInEditMode(item.id)"> {{ item.status ===
                                                                "available" ? "Disponibil" : "Indisponibil" }} </p>
                                                            <div class="input-container" v-if="isItemInEditMode(item.id)">
                                                                <div class="input-group mg-b">
                                                                    <select class="status" v-model="editableItems[item.id].status">
                                                                        <option value="available"> Disponibil</option>
                                                                        <option value="reserved"> Rezervat</option>
                                                                        <option value="sold"> Vandut</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-2 col-lg-20 col-md-12 col-sm-12">
                                                        <div class="level-strip-cell">
                                                            <div class="list-item-actions">
                                                                <a href="javascript:void(0)"
                                                                   @click="openItemDetailModal(item.id,canManage)"
                                                                   class="item-action-btn"
                                                                   data-toggle="tooltip"
                                                                   data-placement="top"
                                                                   title="Vezi Detalii"
                                                                   >
                                                                    <i class="fad fa-eye"></i>
                                                                </a>
                                                                <a href="javascript:void(0)"
                                                                   @click="openEditInlineModelItem(item)"
                                                                   v-if="canManage"
                                                                   data-toggle="tooltip"
                                                                   data-placement="top"
                                                                   title="Modifica"
                                                                   class="item-action-btn"
                                                                >
                                                                    <i class="fad fa-edit"></i>
                                                                </a>
                                                                <a href="javascript:void(0)"
                                                                   v-if="canManage"
                                                                   @click="deleteModelItem(item.id)"
                                                                   class="item-action-btn"
                                                                   data-toggle="tooltip"
                                                                   data-placement="top"
                                                                   title="Sterge"
                                                                >
                                                                    <i class="fad fa-trash-alt"></i>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div class="level-strip-cell level-strip-cell--edit" v-if="isItemInEditMode(item.id)">
                                                            <div class="list-item-actions list-item-actions--edit">
                                                                <a href="javascript:void(0)"
                                                                @click="cancelEditInlineModelItem(item.id)"
                                                                class="developer-list-edit-button developer-list-edit-button--cancel"
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                title="Anulează modificările"
                                                                >
                                                                    Anulează
                                                                </a>
                                                                <a href="javascript:void(0)"
                                                                @click="saveInlineModelItem(item.id)"
                                                                v-if="canManage"
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                title="Salvează modificările"
                                                                class="developer-list-edit-button"
                                                                >
                                                                    Salvează
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        <assign-client></assign-client>-->
        <developer-item-details-modal></developer-item-details-modal>
        <developer-edit-model-items/>
        <public-contact-modal-project></public-contact-modal-project>
    </section>
</template>

<script>
import Swiper from 'swiper/bundle';
// import AssignClient from "./partials/AssignClient";
import DeveloperItemDetailsModal from "./partials/DeveloperItemDetailsModal";
import DeveloperEditModelItems from "./partials/DeveloperEditModelItems";
export default {
    name: "DeveloperModelDetails",
    components: {DeveloperEditModelItems/*, AssignClient*/, DeveloperItemDetailsModal},
    props: ['projectId', 'modelId', 'authId', 'canManage'],
    data() {
        return {
            galleryInitiated: false,
            modelGalleryThumbs: null,
            modelGalleryTop: null,
            model: null,
            project: null,
            images: null,
            thumbs: null,
            activeBuilding: null,
            buildings: null,
            urlParams: null,
            inlineEditItems: []
        }
    },
    async created() {
        this.urlParams = window.getAllUrlParams();
        await this.getModelData()
        let vm = this
        this.$eventBus.$on('MODEL_ITEMS_CHANGED', function () {
            vm.getModelData()
        });
        this.$eventBus.$on('CLIENT_ASSIGNED', function () {
            vm.getModelData()
        });
        setTimeout(function () {
            var scrollElem = document.getElementsByClassName("highlighted-scroll")[0]
            if (scrollElem) {
                scrollElem.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
            }
        }, 500)
// if(this.urlParams && this.urlParams.item) {
//   window.openItemDetailModal(this.urlParams.item)
// }
    },
    computed: {
        levels() {
            let output = []
            for (let i in this.model.items) {
                if (!output[this.model.items[i].level_id]) {
                    output[this.model.items[i].level_id] = {
                        level: null,
                        items: []
                    }
                }
                if (this.model.items[i].building.id === this.activeBuilding.id) {
                    output[this.model.items[i].level_id].level = this.model.items[i].level
                    output[this.model.items[i].level_id].items.push(this.model.items[i])
                }
            }
            output = output.filter(lvl => lvl.items.length > 0);
            output.sort(function (a, b) {
                return a.level.sort_order - b.level.sort_order
            });
            return output;
        },
        editableItems() {
            let items = [];
            this.inlineEditItems.forEach(function (item){
                items[item.id] = item;
            })
            return items;
        },
        itemPrices() {
            let vm = this;
            let prices = [];
            this.model.items.forEach(function (item){
                prices[item.id] = vm.formatPrice(item.price);
            })
            return prices;
        },
        itemPricesWithVat() {
            let result = [];
            this.model.items.forEach(function (item){
                result[item.id] = item.price_with_vat;
            })
            return result;
        },
        itemCreditPrices() {
            let vm = this;
            let prices = [];
            this.model.items.forEach(function (item){
                prices[item.id] = vm.formatPrice(item.credit_price);
            })
            return prices;
        },
        itemCreditPricesWithVat() {
            let result = [];
            this.model.items.forEach(function (item){
                result[item.id] = item.credit_price_with_vat;
            })
            return result;
        },
    },
    mounted() {

    },
    methods: {
        async getModelData() {
            let vm = this
            this.triggerLoader(true)
            await window.axios.get(`/ajax/developer/project/${this.projectId}/model/${this.modelId}/details`)
                .then(function (resp) {
                    vm.model = resp.data.data.model
                    vm.activeBuilding = vm.model.buildings[0]
                    vm.project = resp.data.data.project
                    vm.images = resp.data.data.images
                    vm.thumbs = resp.data.data.thumbs
                    vm.buildings = resp.data.data.buildings
                    vm.triggerLoader(false)
                })
                .catch(function (err) {
                    window.showError(err)
                    vm.triggerLoader(false)
                });
        },
        triggerEditItem(itemId, modelId) {
            this.$refs.editItemModal.getModelData(itemId, modelId, 'edit-model')
        },
        initGalery() {
            if (this.galleryInitiated) return false
            let vm = this
            setTimeout(function () {
                vm.modelGalleryThumbs = new Swiper('.model-gallery-thumbs', {
                    spaceBetween: 10,
                    slidesPerView: 5,
                    freeMode: false,
                    watchActiveIndex: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: '.model-thumbs-button-next',
                        prevEl: '.model-thumbs-button-prev',
                    },
                });

                vm.modelGalleryTop = new Swiper('.model-gallery-top', {
                    spaceBetween: 10,
                    watchActiveIndex: true,
                    navigation: {
                        nextEl: '.model-swiper-button-next',
                        prevEl: '.model-swiper-button-prev',
                    },
                    thumbs: {
                        swiper: vm.modelGalleryThumbs
                    }
                });

                $('.pp-model-gallery').lightGallery({
                    thumbnail: true
                });

            }, 500)

            vm.galleryInitiated = true
        },
        modelGoToSlide(index) {
            this.modelGalleryTop.slideTo(parseInt(index), 0);
        },
        getId(url) {
            let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            let match = url.match(regExp);

            if (match && match[2].length >= 11) {
                return match[2];
            } else {
                return 'error';
            }
        },
        displayVideo(link) {
            let linkId = this.getId(link);
            return "//www.youtube.com/embed/" + linkId
        },
        deleteModelItem(id) {
            let vm = this;
            window.Swal.fire({
                title: 'Esti sigur?',
                text: "Aceste date nu vor mai putea fi recuperate!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Da, sterge!',
                cancelButtonText: 'Nu, anuleaza'
            }).then((result) => {
                if (result.value) {
                    window.axios.delete(`/developer/item/${id}`)
                        .then(function (response) {
                            let html = ''
                            if (response.data.data.type === 'apartment') {
                                html = "Apartamentul a fost sters cu succes."
                            } else if (response.data.data.type === 'house') {
                                html = "Casa a fost stearsa cu succes."
                            } else if (response.data.data.type === 'commercial') {
                                html = "Spatiul comercial a fost sters cu succes."
                            }

                            vm.model.items.forEach(function (item, key) {
                                if (item.id === id) {
                                    vm.model.items.splice(key, 1);

                                    vm.buildings.forEach(function (building) {
                                        if (item.building.id === building.id) {
                                            building.items_count--;
                                        }
                                    });
                                }
                            });
                            window.Swal.fire({
                                html: html,
                                icon: 'success',
                                timer: 2000,
                                showCancelButton: false,
                                showConfirmButton: false
                            })

                        })
                        .catch(function (err) {
                            window.showError(err)
                        });
                }
            })
        },
        openEditInlineModelItem(item) {
            let clone = Object.assign({}, item);
            this.inlineEditItems.push(clone);
        },
        cancelEditInlineModelItem(itemId) {
            this.inlineEditItems = this.inlineEditItems.filter(item => item.id != itemId);
        },
        isItemInEditMode(itemId) {
            return this.inlineEditItems.find(item => item.id == itemId);
        },
        saveInlineModelItem(itemId) {
            let vm = this;
            let editedItem = this.editableItems[itemId];
            if(!editedItem) {
                window.showError('Item invalid');
                return;
            }

            let apartmentNumber = editedItem.apartment_number ? editedItem.apartment_number+'' : '';
            let usefulSurface = editedItem.useful_surface ? editedItem.useful_surface+'' : '';
            let terraceSurface = editedItem.terrace_surface ? editedItem.terrace_surface+'' : '';
            let price = editedItem.price ? editedItem.price+'' : '';
            let priceWithVat = editedItem.price_with_vat ? editedItem.price_with_vat+'' : '';
            let creditPrice = editedItem.credit_price ? editedItem.credit_price+'' : '';
            let creditPriceWithVat = editedItem.credit_price_with_vat ? editedItem.credit_price_with_vat+'' : '';
            let status = editedItem.status ? editedItem.status+'' : '';

            let formData = new FormData();
            formData.append('apartmentNumber', apartmentNumber);
            formData.append('usefulSurface', usefulSurface);
            formData.append('terraceSurface', terraceSurface);
            formData.append('price', price);
            formData.append('priceWithVat', priceWithVat);
            formData.append('creditPrice', creditPrice);
            formData.append('creditPriceWithVat', creditPriceWithVat);
            formData.append('status', status);

            window.axios.post('/developer/'+this.projectId+'/model/'+this.modelId+'/item/'+itemId+'/edit', formData)
                .then(function (response) {
                    let html = ''
                    if (response.data.data.type === 'apartment') {
                        html = "Apartamentul a fost modificat cu succes."
                    } else if (response.data.data.type === 'house') {
                        html = "Casa a fost modificata cu succes."
                    } else if (response.data.data.type === 'commercial') {
                        html = "Spatiul comercial a fost modificat cu succes."
                    }

                    vm.model.items.forEach(function (item){
                        if(item.id == response.data.data.id) {
                            item.apartment_number = response.data.data.apartment_number;
                            item.useful_surface = response.data.data.useful_surface;
                            item.terrace_surface = response.data.data.terrace_surface;
                            item.price = response.data.data.price;
                            item.price_with_vat = response.data.data.price_with_vat;
                            item.credit_price = response.data.data.credit_price;
                            item.credit_price_with_vat = response.data.data.credit_price_with_vat;
                            item.status = response.data.data.status;
                            vm.cancelEditInlineModelItem(item.id);
                        }
                    })

                    window.Swal.fire({
                        html: html,
                        icon: 'success',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    })
                })
                .catch(function (err) {
                    window.showError(err)
                });
        },
    }
}
</script>